import { EventEmitter } from 'events';

class SwebEventEmitter {
  ee: EventEmitter;
  constructor() {
    this.ee = new EventEmitter();
    if (this.getOS() === 'Android') {
      document && document.addEventListener("message", (response) => {
        try {
          if (response && response.data && typeof response.data === 'string' || response.data instanceof String) {
            const { message, event, error, storeInfo, deviceInfo, deviceApi, RNDevEnv, deviceTypeId } = JSON.parse(response.data);
            if (storeInfo && storeInfo.data && deviceInfo) {
              this.ee.emit(event, storeInfo, deviceInfo, null, deviceApi, RNDevEnv, deviceTypeId);
            } else if (message) {
              this.ee.emit(event, message, null);
            } else {
              this.ee.emit(event, null, error);
            }
          }
        } catch (error) {
          console.error('document.addEventListener("message") error', error, response);
        }
      });
      window && window.addEventListener("message", (response) => {
        try {
          if (response && response.data && typeof response.data === 'string' || response.data instanceof String) {
            const { message, event, error, storeInfo, deviceInfo, deviceApi, RNDevEnv, deviceTypeId } = JSON.parse(response.data);
            if (storeInfo && storeInfo.data && deviceInfo) {
              this.ee.emit(event, storeInfo, deviceInfo, null, deviceApi, RNDevEnv, deviceTypeId);
            } else if (message) {
              this.ee.emit(event, message, null);
            } else {
              this.ee.emit(event, null, error);
            }
          }
        } catch (error) {
          console.error('window.addEventListener("message") error', error, response);
        }
      });
    } else {
      window && window.addEventListener("message", (response) => {
        try {
          if (response && response.data && typeof response.data === 'string' || response.data instanceof String) {
            const { message, event, error, storeInfo, deviceInfo, deviceApi, RNDevEnv, deviceTypeId } = JSON.parse(response.data);
            if (storeInfo && storeInfo.data && deviceInfo) {
              this.ee.emit(event, storeInfo, deviceInfo, null, deviceApi, RNDevEnv, deviceTypeId);
            } else if (message) {
              this.ee.emit(event, message, null);
            } else {
              this.ee.emit(event, null, error);
            }
          }
        } catch (error) {
          console.error('window.addEventListener("message") error', error, response);
        }
      });
    }
  }

  getOS = () => {
    var userAgent = window.navigator.userAgent,
      platform = window.navigator.platform,
      macosPlatforms = ['Macintosh', 'MacIntel', 'MacPPC', 'Mac68K'],
      iosPlatforms = ['iPhone', 'iPad', 'iPod'],
      os = null;
    if (iosPlatforms.indexOf(platform) !== -1 || macosPlatforms.indexOf(platform) !== -1) {
      os = 'iOS';
    } else if (/Android/.test(userAgent)) {
      os = 'Android';
    }
    return os;
  }

  addListeners = (event, callback) => {
    this.ee.on(event, callback);
  }

  removeListeners = (event, callback) => {
    this.ee.off(event, callback);
  }

  sendMessage = (data, successCallback, errorCallback) => {
    const { type } = data;
    var listener = (success, error) => {
      if (success) {
        successCallback && successCallback(success);
      } else if (error) {
        errorCallback && errorCallback(error);
      }
      this.removeListeners(type, listener);
    };
    this.addListeners(type, listener);
    window.ReactNativeWebView.postMessage(JSON.stringify(data));
  }

  activateDevice = (callback) => {
    var listener = (storeInfo, deviceInfo, mode, deviceApi, RNDevEnv, deviceTypeId) => {
      callback && callback(storeInfo, deviceInfo, mode, deviceApi, RNDevEnv, deviceTypeId);
      this.removeListeners('activation', listener);
    };
    this.addListeners('activation', listener);
  }

  syncStatus = status => {
    if (window.ReactNativeWebView) {
      const data = {
        type: 'syncStatus',
        status: status,
      };
      window.ReactNativeWebView.postMessage(JSON.stringify(data));
    }
  };

  playAudio = (play) => {
    const data = {
      type: 'playAudio',
      play: play,
    };
    window.ReactNativeWebView.postMessage(JSON.stringify(data));
  }

  sendVenueInfo = storeName => {
    const data = {
      type: 'venueInfo',
      storeName: storeName,
    };
    window.ReactNativeWebView.postMessage(JSON.stringify(data));
  }

  sendException = (error) => {
    const data = {
      type: 'exception',
      error: error,
    };
    window.ReactNativeWebView.postMessage(JSON.stringify(data));
  }

  sendAppMode = version => {
    window.ReactNativeWebView.postMessage(JSON.stringify({
      type: 'appMode',
      appMode: process.env.REACT_APP_MODE,
      webAppVersion: version,
    }));
  }

  restartApp = () => {
    const data = {
      type: 'restartApp',
    };
    window.ReactNativeWebView.postMessage(JSON.stringify(data));
  };

  addSwebLog = (message, stackTrace) => {
    if (window.ReactNativeWebView) {
      const data = {
        type: 'webLogs',
        log: { message, stackTrace },
      };
      window.ReactNativeWebView.postMessage(JSON.stringify(data));
    }
  };

  addLogs = (type, logLevel, logMessage) => {
    if (window.ReactNativeWebView) {
      const data = {
        type: type,
        data: { logLevel, logMessage },
      };
      window.ReactNativeWebView.postMessage(JSON.stringify(data));
    }
  };

  initializeIngenico = () => {
    if (window.ReactNativeWebView) {
      const data = {
        type: 'initializeIngenico',
      };
      window.ReactNativeWebView.postMessage(JSON.stringify(data));
    }
  };

  scanQRCodeToRedeem = (type) => {
    if (window.ReactNativeWebView) {
      window.ReactNativeWebView.postMessage(JSON.stringify({ type }));
    }
  }

  scanQRCode = type => {
    if (window.ReactNativeWebView) {
      window.ReactNativeWebView.postMessage(JSON.stringify({ type }));
    }
  }

  launchExternalApp = url => {
    if (window.ReactNativeWebView) {
      window.ReactNativeWebView.postMessage(JSON.stringify({
        type: 'lauchExternalApp',
        data: { url },
      }));
    }
  }

  changeOrientation = orientation => {
    if (window.ReactNativeWebView) {
      window.ReactNativeWebView.postMessage(JSON.stringify({
        type: 'changeOrientation',
        data: { orientation },
      }));
    }
  };

}

export default new SwebEventEmitter();